export const NetworkContextName = 'NETWORK'

// transaction popup dismisal amounts
export const DEFAULT_TXN_DISMISS_MS = 25000
